const milSecToMinsFactor: number = 60000;
const updateTokenBeforeExpiryMins: number = 10;

export { milSecToMinsFactor, updateTokenBeforeExpiryMins };
